<template>
	<div class="TraingameSeting">
		<div class="left">
			<ul>
				<template class="box">
					<li
						v-for="(item,index) in navList"
						:key="item.id"
						@click="changeNav(index)"
						:class="index == currentNav ? 'active' : type == 'add' ? 'noclick' : ''">{{item}}</li>
				</template>
			</ul>
		</div>
		<div class="right">
			<BaseSet v-if="currentNav == 0" @changeType="changeType" :pagetype='type'></BaseSet>
			<AblitySet v-if="currentNav == 1"></AblitySet>
			<VersionsSet v-if="currentNav == 2"></VersionsSet>
		</div>
	</div>
</template>

<script>
import BaseSet from "./components/BaseSet.vue";
import AblitySet from "./components/AblitySet";
import VersionsSet from "./components/VersionsSet";
import $Bus from "@/pages/projectImpl/js/eventBus";
export default {
	components: { BaseSet ,AblitySet ,VersionsSet},
	data () {
		return {
			navList:['基本设置','能力设置','版本管理'],
			currentNav:0,
      		type: this.$store.getters["content/getTrainGameInfo"]() ? 'edit' : 'add',
		}
	},
	mounted(){
		this.setTitle()
	},
	methods:{
		setTitle() {
			const info = this.$store.getters["content/getTrainGameInfo"]();
			console.log(info);
			let tabName = "训练游戏配置"
			if (this.type == "edit") {
				tabName = `${info.name || this.$route.query.name}${info.versionName ? ' - ' + info.versionName : ''} 配置`;
			}
			const arr = ["首页", "内容中心", {name: "训练游戏管理", path: info.fullPath || "/content/Traingame"}, "训练游戏配置"];
			$Bus.$emit("pageHeaderBreadcrumb", arr);
			$Bus.$emit("pageHeaderTitle", tabName);
			$Bus.$emit("updateTabName", {path: this.$route.path, name: tabName});
		},
		// 切换左边
		changeNav(index){
			if(this.type == 'add'){
				if(index == 0){
					this.currentNav = index
				}
			}else{
				this.currentNav = index
			}
		},
		// 接收子组件传参
		changeType(val){
			this.type = val
			setTimeout(()=>{
				this.setTitle()
			},100)
		},
	}
}
</script>

<style lang="less" scoped>
.TraingameSeting{
	min-height: 400px;
	padding: 5px 0;
	display: flex;
	width: 100%;
	background-color: #fff;
	.left{
		width: 15%;
		border-right:1px solid #f2f2f2;
		ul{
			width: 100%;
			padding: 0;
			li{
				list-style: none;
				height: 50px;
				display: flex;
				justify-content: center;
				align-items: center;
				cursor: pointer;
			}
			.active{
				background: rgb(230,247,255);
				color:#1890ff;
				border-right:4px solid #1890ff;
			}
			.noclick{
				cursor: not-allowed;
				background: #f4f4f4;
				opacity: 0.6;
			}
		}
	}
	.right{
		flex: 1;
		padding: 10px 20px;
	}
}
</style>
